export default "__VITE_ASSET__htFbWUrX__"